import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  RouteComponentProps,
  Redirect,
} from "react-router-dom";
import Layout from "./components/containers/Layout";
import LoginRequiredRoute from "./routes/LoginRequiredRoute";
import Login from "./pages/Login";
import routes from "./routes";
import PermissionRequiredRoute from "./routes/PermissionRequiredRoute";
import RecordDetailPage from "./dashboard-pages/RecordDetailPage";
import RecordSearchPage from "./dashboard-pages/RecordSearchPage";
import DynamicTitle from "./components/utils/DynamicTitle";
import RecordPreviewPage from "./dashboard-pages/RecordPreviewPage";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

function AppRouter() {
  let routeComponents: React.ReactElement[] = [];
  for (const key in routes) {
    const route = routes[key];

    if (route.permissionName !== undefined) {
      routeComponents.push(
        <LoginRequiredRoute
          key={key}
          path={route.path}
          exact={route.exact}
          render={(props: RouteComponentProps) => (
            <PermissionRequiredRoute permissionName={route.permissionName!}>
              <Layout {...props} />
            </PermissionRequiredRoute>
          )}
        />
      );
    } else {
      routeComponents.push(
        <LoginRequiredRoute
          key={key}
          path={route.path}
          exact={route.exact}
          render={(props: RouteComponentProps) => <Layout {...props} />}
        />
      );
    }
  }

  return (
    <Router>
      <React.Suspense fallback={loading}>
        <DynamicTitle />
        <Switch>
          <Route path="/login" component={Login} />
          <Route
            path="/records/:id"
            exact={true}
            component={RecordDetailPage}
          />
          <Route
            path="/records_search/:id"
            exact={true}
            component={RecordPreviewPage}
          />
          <Route
            path="/search/:searchterm"
            exact={true}
            component={RecordSearchPage}
          />
          {routeComponents}
          <Redirect from="/" to="/dashboard" />
        </Switch>
      </React.Suspense>
    </Router>
  );
}

export default AppRouter;
